
import React, { useState, useEffect } from 'react';
import { motion , AnimatePresence} from 'framer-motion';
import { Mail, Github, Linkedin, Download, ArrowRight } from 'lucide-react';
import { PROFILE } from '../constants';

const Header: React.FC = () => {
  const { name, role, bio, avatar, avatar2 } = PROFILE;
  const sequence = [name, "A Full Stack Developer", "A WordPress Developer", "A Technical Virtual Assistant", "An AI Enthusiast", "An IT Instructor"];
  const [index, setIndex] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % sequence.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);
  return (
    <div className="relative pt-32 pb-32 overflow-hidden">
      {/* Mesh Gradient Background Blobs */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl -z-10">
        <div className="absolute top-10 left-10 w-72 h-72 bg-blue-400/30 rounded-full blur-3xl animate-blob"></div>
        <div className="absolute top-20 right-10 w-72 h-72 bg-indigo-400/30 rounded-full blur-3xl animate-blob animation-delay-2000"></div>
        <div className="absolute bottom-20 left-1/4 w-72 h-72 bg-purple-400/20 rounded-full blur-3xl animate-blob animation-delay-4000"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center flex flex-col items-center">
        <motion.div 
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="relative mb-8"
        >
   <motion.div 
  whileHover="hover"
  animate={{ y: [0, -10, 0] }}
  transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
  className="relative w-40 h-40 md:w-48 md:h-48 rounded-2xl overflow-hidden ring-4 ring-blue-500/20 shadow-2xl cursor-pointer"
>
  {/* The Hover Image (Bottom Layer) */}
  <img 
    src={avatar2} 
    alt="Profile Hover" 
    className="absolute inset-0 w-full h-full object-cover"
  />

  {/* The Default Image (Top Layer) */}
  <motion.img 
    src={avatar} 
    alt="Profile" 
    variants={{
      hover: { opacity: 0 } // Fades out when parent is hovered
    }}
    transition={{ duration: 0.3 }}
    className="absolute inset-0 w-full h-full object-cover z-10"
  />
</motion.div>
          <div className="absolute -bottom-2 -right-2 bg-green-500 w-6 h-6 rounded-full border-4 border-white dark:border-slate-950 shadow-lg"></div>
        </motion.div>

<motion.h1 
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      className="text-4xl md:text-7xl font-extrabold tracking-tight mb-4"
    >
      Hello, I'm{" "}
      <span className="inline-block min-w-[200px]">
        <AnimatePresence mode="wait">
          <motion.span
            key={sequence[index]}
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -20, opacity: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
            className="bg-gradient-to-r from-blue-600 to-indigo-500 bg-clip-text text-transparent inline-block"
          >
            {sequence[index]}
          </motion.span>
        </AnimatePresence>
      </span>
    </motion.h1>
        
        <motion.h2 
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.3 }}
          className="text-xl md:text-2xl text-slate-600 dark:text-slate-400 font-medium mb-8 max-w-2xl"
        >
          {bio}
        </motion.h2>

        <motion.div 
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.4 }}
          className="flex flex-wrap justify-center gap-4 mb-12"
        >
          <a href="mailto:aldaykimvincent@gmail.com">
          <motion.button 
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-xl font-bold shadow-lg shadow-blue-500/30 transition-all"
          >
            Hire Me <ArrowRight size={20} />
          </motion.button>
          </a>
          <motion.button 
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="flex items-center gap-2 bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700 text-slate-900 dark:text-white px-8 py-4 rounded-xl font-bold transition-all"
          >
            Download CV <Download size={20} />
          </motion.button>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
          className="flex items-center gap-8"
        >
          <a href="https://github.com/kimvincent09/" className="text-slate-500 hover:text-blue-600 dark:hover:text-blue-400 transition-colors transform hover:scale-110"><Github size={26} /></a>
          <a href="https://www.linkedin.com/in/kim-vincent-0399bb164/" className="text-slate-500 hover:text-blue-600 dark:hover:text-blue-400 transition-colors transform hover:scale-110"><Linkedin size={26} /></a>
          <a href="mailto:aldaykimvincent@gmail.com" className="text-slate-500 hover:text-blue-600 dark:hover:text-blue-400 transition-colors transform hover:scale-110"><Mail size={26} /></a>
        </motion.div>
      </div>
    </div>
  );
};

export default Header;
